import React, { useRef, useState, useEffect } from 'react';
import TextField from '@mui/material/TextField';

import { LocalizationProvider, TimePicker } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';

import { Grid, Typography, Stack, FormControl, InputLabel, Select, MenuItem, OutlinedInput, Checkbox, DialogContentText, ListItemText, Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material';

import { useSnackbar } from '../SnackBar';

import { useBranchContext } from '../../components/Context/BranchContext';

import { styled } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import dayjs from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import ConfirmDialog from '../ConfirmDialog';
import EditDialogBodyType from '../EditDialog/EditDialogBodyType';
import { useProgressBar } from '../ProgressBar';
const libraries = ["places"];

const BranchAdminView = () => {

    const navigate = useNavigate()
    const userType = localStorage.getItem('userType');
    var styles = { inputDisabled: { border: 'none', background: 'none' } };
    if (userType === 'ADMIN') {
        styles = { inputDisabled: { border: 'none', background: 'none', pointerEvents: 'none' } };
    } else if (userType === 'PARTNER') {
        styles = { inputDisabled: { border: 'none', background: 'none', pointerEvents: 'none' } };
    }
    const CustomTextField = styled(TextField)({ '& .MuiInputBase-input': { padding: '4px 0 5px !important', }, });
    const { showSnackbar } = useSnackbar();
    const [serviceCategories, setServiceCategories] = useState([]); // Options from API

    const [selectedCategories, setSelectedCategories] = useState([]);
    const { FetchServiceCategory, category, loadBranch, ActivateBranchById, ApproveBranchById, deleteBranch } = useBranchContext(); // Use your context function
    const { showProgress } = useProgressBar();
    const [location, setLocation] = useState("");
    const didFetch = useRef(false);
    const { id, edit } = useParams();
    const [open, setOpen] = useState(false);
    const [editOpen, setEditOpen] = useState(false);
    const [editType, setEditType] = useState('brand'); // 'brand' or 'model'
    const [currentEditData, setCurrentEditData] = useState(null);
    const [showApproved, setShowApproved] = useState(false);
    const [selectedBodyId, setSelectedBodyId] = useState(null); // Store the ID of the brand to delete
    const [approved, setApproved] = useState(false);

    // Refs for each input field
    const nameRef = useRef(null);
    const streetRef = useRef(null);
    const buildingRef = useRef(null);
    const neighborhoodRef = useRef(null);
    const cityRef = useRef(null);
    const stateRef = useRef(null);
    const zipRef = useRef(null);
    const countryRef = useRef(null);
    const latitudeRef = useRef(null);
    const longitudeRef = useRef(null);
    const aboutRef = useRef(null);
    const phoneRef = useRef(null);
    const emailRef = useRef(null);
    const statusRef = useRef(null);

    const mondayOpenRef = useRef(null);
    const mondayCloseRef = useRef(null);
    const tuesdayOpenRef = useRef(null);
    const tuesdayCloseRef = useRef(null);
    const wednesdayOpenRef = useRef(null);
    const wednesdayCloseRef = useRef(null);
    const thursdayOpenRef = useRef(null);
    const thursdayCloseRef = useRef(null);
    const fridayOpenRef = useRef(null);
    const fridayCloseRef = useRef(null);
    const saturdayOpenRef = useRef(null);
    const saturdayCloseRef = useRef(null);
    const sundayOpenRef = useRef(null);
    const sundayCloseRef = useRef(null);

    const [branchData, setBranchDetails] = useState({
        id: 0, // Replace with actual values
        name: "",
        streetName: "",
        buildingNumber: "",
        neighborhood: "",
        city: "",
        state: "",
        zipCode: "",
        country: "",
        latitude: "",
        longitude: "",
        aboutUs: "",
        phone: "",
        email: "",
        mondayOpen: "",
        mondayClose: "",
        tuesdayOpen: "",
        tuesdayClose: "",
        wednesdayOpen: "",
        wednesdayClose: "",
        thursdayOpen: "",
        thursdayClose: "",
        fridayOpen: "",
        fridayClose: "",
        saturdayOpen: "",
        saturdayClose: "",
        sundayOpen: "",
        sundayClose: "",
        category: [""]
    });

    const fetchData = async () => {
        try {
            const serviceCategories = await FetchServiceCategory();
            setServiceCategories(serviceCategories);

            if (id) {
                const branch = await loadBranch(id);
                setBranchDetails(branch);

                setSelectedCategories(branch.category || []);
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    useEffect(() => {
        if (!didFetch.current) {
            fetchData();

            didFetch.current = true;
        }
    });
    useEffect(() => {
        setApproved(branchData.isApproved); // Update approval status based on API data
    }, [branchData]);
    const [selectedOptions, setSelectedOptions] = useState([]);
    // Display selected options or placeholder text if none are selected
    const selectedText =
        selectedOptions.length > 0
            ? selectedOptions.join(", ")
            : "Select Options";
    const handleOptionToggle = (option) => {
        setSelectedOptions((prevSelected) =>
            prevSelected.includes(option)
                ? prevSelected.filter((item) => item !== option)
                : [...prevSelected, option]
        );
    };

    const handelEdit = () => {
        // Navigate to the edit form with the branch ID
        navigate(`/edit-branch/${branchData.id}/true`, { state: { branch: branchData } });
    };

    const handleInputChange = (e) => {

        if (e.target.name === 'street') {
            setLocation(e.target.value);
        }
        const { name, value } = e.target;
        setBranchDetails((prevDetails) => ({
            ...prevDetails,
            [name]: value,
        }));
    }; const handleTimeChange = (newValue, field) => {
        if (newValue) {
            setBranchDetails((prevState) => ({
                ...prevState,
                [field]: newValue.format("hh:mm A"), // Format the value to "hh:mm A"
            }));
        }
    };
    const handleChange = (event) => { const { value, checked } = event.target; if (checked) { setSelectedCategories([...selectedCategories, value]); } else { setSelectedCategories(selectedCategories.filter(option => option !== value)); } };



    const handleClose = () => {
        setOpen(false); // Close the confirmation dialog 
    };

    const handleConfirm = async () => {
        try {
            await ApproveBranchById(branchData);
            branchData.isApproved = true;

            showSnackbar('Branch approved successfully');
            setApproved(true);
            setOpen(false); // Close the dialog after successful confirmation
        } catch (error) {
            console.error('Error approving branch:', error);
        }
    };

    const handleApproveClick = () => {
        setOpen(true); // Open the confirmation dialog
    };
    const [confirmStatusOpen, setConfirmStatusOpen] = useState(false); // For activation/deactivation dialog
    const [confirmDeleteOpen, setConfirmDeleteOpen] = useState(false); // For delete dialog
    const [pendingStatus, setPendingStatus] = useState(null);

    // Handlers for Status Change Confirmation Dialog
    const handleActive = (event) => {
        const isActive = event.target.checked;
        setPendingStatus(isActive); // Store the new status
        setConfirmStatusOpen(true); // Open the confirmation dialog for status change
    };

    const handleConfirmStatusChange = async () => {
        const value = pendingStatus ? 'true' : 'false';
        const branchId = branchData.id;
        debugger;
        branchData.isActive = pendingStatus; // Update the branch status locally
        await ActivateBranchById(branchId, value); // Call the API
        showSnackbar(`Branch ${pendingStatus ? 'Activated' : 'Deactivated'} Successfully`);
        setConfirmStatusOpen(false); // Close the dialog
    };

    const handleStatusDialogClose = () => {
        setConfirmStatusOpen(false); // Close the dialog
    };

    // Handlers for Delete Confirmation Dialog
    const handleDeleteClick = () => {
        setConfirmDeleteOpen(true); // Open the delete confirmation dialog
    };

    const handleConfirmDelete = async () => {
        setConfirmDeleteOpen(false); // Close the dialog
        if (branchData.id) {
            debugger;
            deleteBranch(branchData.id);
            showSnackbar('Branch deleted successfully', 'success');
            navigate('/newbranch'); // Delete the selected brand
        }
    };

    const handleDeleteDialogClose = () => {
        setConfirmDeleteOpen(false); // Close the dialog
    };
    return (

        <main id="main" className="main">
            <div className="pagetitle">

                <nav>
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item"><a href="/admin">Home</a></li>
                        <li className="breadcrumb-item"><a href="/allbranch">Branch</a> </li>
                        <li className="breadcrumb-item active"><a href="#">manage Branch</a></li>
                    </ol>
                </nav>
            </div>
            <section className="section">
                <div className="row">
                    <div className="card">
                        <div className="card-body">
                            <div className="row">
                                <nav className="navbar navbar-expand-lg navbar-light">
                                    <div className="container-fluid">

                                        <div className="collapse navbar-collapse" id="navbarSupportedContent">
                                            <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                                                <h4 className="mb-3">Branch Details</h4>
                                            </ul>
                                            {userType != "ADMIN" && <>
                                                <Button className="right-button me-2"
                                                    variant="contained"

                                                    style={{ backgroundColor: '#02176D', color: 'white' }}
                                                    onClick={handelEdit} >
                                                    Edit
                                                </Button>
                                                <Button
                                                    variant="contained"
                                                    style={{ backgroundColor: '#02176D', color: 'white' }}
                                                    onClick={handleDeleteClick}
                                                    className="right-button"
                                                >
                                                    Delete Branch
                                                </Button></>
                                            }
                                        </div>
                                    </div>
                                </nav>
                                <div className="col-lg-6">

                                    <div className="card-body">
                                        <h5 className="card-title">Branch Details</h5>

                                        <form>
                                            <div className="row mb-4">
                                                <label htmlFor="inputText" className="col-sm-3 col-form-label">Name</label>
                                                <div className="col-sm-8">
                                                    <input type="text" style={styles.inputDisabled} className="form-control" name="name" value={branchData.name} onChange={handleInputChange} ref={nameRef} />
                                                </div>
                                            </div>

                                            <div className="row mb-4">
                                                <label htmlFor="inputText" className="col-sm-3 col-form-label">Building Number</label>
                                                <div className="col-sm-8">
                                                    <input style={styles.inputDisabled} type="text" name="buildingNumber" className="form-control" value={branchData.buildingNumber} ref={buildingRef} onChange={handleInputChange} />
                                                </div>
                                            </div>
                                            <div className="row mb-4">
                                                <label htmlFor="inputText" className="col-sm-3 col-form-label">Neighborhood</label>
                                                <div className="col-sm-8">
                                                    <input style={styles.inputDisabled} type="text" name="neighborhood" className="form-control" value={branchData.neighborhood} ref={neighborhoodRef} onChange={handleInputChange} />
                                                </div>
                                            </div>
                                            <div className="row mb-4">
                                                <label htmlFor="inputText" className="col-sm-3 col-form-label">City</label>
                                                <div className="col-sm-8">
                                                    <input style={styles.inputDisabled} type="text" name="city" className="form-control" value={branchData.city} ref={cityRef} onChange={handleInputChange} />
                                                </div>
                                            </div>
                                            <div className="row mb-4">
                                                <label htmlFor="inputText" className="col-sm-3 col-form-label">State</label>
                                                <div className="col-sm-8">
                                                    <input style={styles.inputDisabled} className="form-control" name="state" type="text" id="formFile" value={branchData.state} ref={stateRef} onChange={handleInputChange} />
                                                </div>
                                            </div>
                                            <div className="row mb-4">
                                                <label htmlFor="inputText" className="col-sm-3 col-form-label">Zip Code</label>
                                                <div className="col-sm-8">
                                                    <input style={styles.inputDisabled} className="form-control" name="zipCode" type="text" id="formFile" value={branchData.zipCode} ref={zipRef} onChange={handleInputChange} />
                                                </div>
                                            </div>
                                            <div className="row mb-4">
                                                <label htmlFor="inputText" className="col-sm-3 col-form-label">Country</label>
                                                <div className="col-sm-8">
                                                    <input style={styles.inputDisabled} className="form-control" name="country" type="text" id="formFile" value={branchData.country} ref={countryRef} onChange={handleInputChange} />
                                                </div>
                                            </div>
                                            <div className="row mb-4">
                                                <label htmlFor="inputText" className="col-sm-3 col-form-label">Email</label>
                                                <div className="col-sm-8">
                                                    <input style={styles.inputDisabled} className="form-control" name="email" type="email" id="formFile" value={branchData.email} ref={emailRef} onChange={handleInputChange} />
                                                </div>
                                            </div>
                                            <div className="row mb-4">
                                                <label htmlFor="inputNumber" className="col-sm-3 col-form-label">Phone</label>
                                                <div className="col-sm-8">
                                                    <input style={styles.inputDisabled} className="form-control" name="email" type="email" id="formFile" value={branchData.phone} ref={phoneRef} onChange={handleInputChange} />
                                                </div>
                                            </div>
                                            <div className="row mb-4">
                                                <label htmlFor="inputText" className="col-sm-3 col-form-label">About</label>
                                                <div className="col-sm-8">
                                                    <input style={styles.inputDisabled} type="text" name="aboutUs" className="form-control" value={branchData.aboutUs} ref={aboutRef} onChange={handleInputChange} />
                                                </div>
                                            </div>


                                            <div className="row mb-5">
                                                <label htmlFor="inputColor" className="col-sm-3 col-form-label">Service Category</label>
                                                <div className="col-sm-8">

                                                    {selectedCategories.map((option, index) => (<div className="form-check" key={index}> <label className="form-check-label">{option.name}</label> </div>))}
                                                </div>
                                            </div>
                                            <div className="row mb-6 align-items-center">
                                                <label className="col-sm-4 col-form-label">Branch Status</label>
                                                <div className="col-sm-4">
                                                    <div className="form-check form-switch">
                                                        <input
                                                            className="form-check-input"
                                                            type="checkbox"
                                                            id="flexSwitchCheckDefault"
                                                            checked={branchData.isActive}
                                                            onChange={handleActive}
                                                        />
                                                        <label className="form-check-label" htmlFor="flexSwitchCheckDefault">Active</label>
                                                    </div>
                                                </div>

                                                {userType === 'ADMIN' && (
                                                    <div className="col-sm-4">
                                                        {!approved && (
                                                            <button type="button" className="btn btn-primary" onClick={handleApproveClick}>
                                                                Approve
                                                            </button>
                                                        )}
                                                    </div>
                                                )}

                                                {/* Confirmation Dialog */}
                                                <Dialog open={confirmStatusOpen} onClose={handleStatusDialogClose}>
                                                    <DialogTitle>Confirm Status Change</DialogTitle>
                                                    <DialogContent>
                                                        <DialogContentText>
                                                            Are you sure you want to {pendingStatus ? 'activate' : 'deactivate'} this branch?
                                                        </DialogContentText>
                                                    </DialogContent>
                                                    <DialogActions>
                                                        <Button onClick={handleStatusDialogClose} color="secondary">
                                                            Cancel
                                                        </Button>
                                                        <Button onClick={handleConfirmStatusChange} color="primary" autoFocus>
                                                            Confirm
                                                        </Button>
                                                    </DialogActions>
                                                </Dialog>
                                            </div>

                                        </form>
                                    </div>


                                </div> <div className="col-lg-6">



                                    <div className="card-body">
                                        <h5 className="card-title">Branch Operational Hours</h5>
                                        <Grid item xs={12} sm={6}>
                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                <Grid container spacing={2}>
                                                    <Grid item xs={12}>
                                                        <Grid container spacing={2}>
                                                            <Grid item xs={6}>
                                                                <TimePicker

                                                                    InputProps={{ style: styles.inputDisabled }}
                                                                    name="Monday Open"
                                                                    inputRef={mondayOpenRef}
                                                                    value={dayjs(branchData.mondayOpen.toString(), "hh:mm A")}
                                                                    onChange={(newValue) => handleTimeChange(newValue, 'mondayOpen')}
                                                                    renderInput={(params) => <TextField {...params} />}
                                                                />
                                                            </Grid>
                                                            <Grid item xs={6}>
                                                                <TimePicker
                                                                    label="Monday Close"
                                                                    inputRef={mondayCloseRef}
                                                                    value={dayjs(branchData.mondayClose.toString(), "hh:mm A")}
                                                                    onChange={(newValue) => handleTimeChange(newValue, 'mondayClose')}
                                                                    renderInput={(params) => <TextField {...params} />}
                                                                />
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <Grid container spacing={2}>
                                                            <Grid item xs={6}>
                                                                <TimePicker
                                                                    label="Tuesday Open"
                                                                    inputRef={tuesdayOpenRef}
                                                                    value={dayjs(branchData.tuesdayOpen.toString(), "hh:mm A")}
                                                                    onChange={(newValue) => handleTimeChange(newValue, 'tuesdayOpen')}
                                                                    renderInput={(params) => <TextField {...params} />}
                                                                />
                                                            </Grid>
                                                            <Grid item xs={6}>
                                                                <TimePicker
                                                                    label="Tuesday Close"
                                                                    inputRef={tuesdayCloseRef}
                                                                    value={dayjs(branchData.tuesdayClose.toString(), "hh:mm A")}
                                                                    onChange={(newValue) => handleTimeChange(newValue, 'tuesdayClose')}
                                                                    renderInput={(params) => <TextField {...params} />}
                                                                />
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <Grid container spacing={2}>
                                                            <Grid item xs={6}>
                                                                <TimePicker
                                                                    label="Wednesday Open"
                                                                    inputRef={wednesdayOpenRef}
                                                                    value={dayjs(branchData.wednesdayOpen.toString(), "hh:mm A")}
                                                                    onChange={(newValue) => handleTimeChange(newValue, 'wednesdayOpen')}
                                                                    renderInput={(params) => <TextField {...params} />}
                                                                />
                                                            </Grid>
                                                            <Grid item xs={6}>
                                                                <TimePicker
                                                                    label="Wednesday Close"
                                                                    inputRef={wednesdayCloseRef}
                                                                    value={dayjs(branchData.wednesdayClose.toString(), "hh:mm A")}
                                                                    onChange={(newValue) => handleTimeChange(newValue, 'wednesdayClose')}
                                                                    renderInput={(params) => <TextField {...params} />}
                                                                />
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <Grid container spacing={2}>
                                                            <Grid item xs={6}>
                                                                <TimePicker
                                                                    label="Thursday Open"
                                                                    inputRef={thursdayOpenRef}
                                                                    value={dayjs(branchData.thursdayOpen.toString(), "hh:mm A")}
                                                                    onChange={(newValue) => handleTimeChange(newValue, 'thursdayOpen')}
                                                                    renderInput={(params) => <TextField {...params} />}
                                                                />
                                                            </Grid>
                                                            <Grid item xs={6}>
                                                                <TimePicker
                                                                    label="Thursday Close"
                                                                    inputRef={thursdayCloseRef}
                                                                    value={dayjs(branchData.thursdayClose.toString(), "hh:mm A")}
                                                                    onChange={(newValue) => handleTimeChange(newValue, 'thursdayClose')}
                                                                    renderInput={(params) => <TextField {...params} />}
                                                                />
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <Grid container spacing={2}>
                                                            <Grid item xs={6}>
                                                                <TimePicker
                                                                    label="Friday Open"
                                                                    inputRef={fridayOpenRef}
                                                                    value={dayjs(branchData.fridayOpen.toString(), "hh:mm A")}
                                                                    onChange={(newValue) => handleTimeChange(newValue, 'fridayOpen')}
                                                                    renderInput={(params) => <TextField {...params} />}
                                                                />
                                                            </Grid>
                                                            <Grid item xs={6}>
                                                                <TimePicker
                                                                    label="Friday Close"
                                                                    inputRef={fridayCloseRef}
                                                                    value={dayjs(branchData.fridayClose.toString(), "hh:mm A")}
                                                                    onChange={(newValue) => handleTimeChange(newValue, 'fridayClose')}
                                                                    renderInput={(params) => <TextField {...params} />}
                                                                />
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <Grid container spacing={2}>
                                                            <Grid item xs={6}>
                                                                <TimePicker
                                                                    label="Saturday Open"
                                                                    inputRef={saturdayOpenRef}
                                                                    value={dayjs(branchData.saturdayOpen.toString(), "hh:mm A")}
                                                                    onChange={(newValue) => handleTimeChange(newValue, 'saturdayOpen')}
                                                                    renderInput={(params) => <TextField {...params} />}
                                                                />
                                                            </Grid>
                                                            <Grid item xs={6}>
                                                                <TimePicker
                                                                    label="Saturday Close"
                                                                    inputRef={saturdayCloseRef}
                                                                    value={dayjs(branchData.saturdayClose.toString(), "hh:mm A")}
                                                                    onChange={(newValue) => handleTimeChange(newValue, 'saturdayClose')}
                                                                    renderInput={(params) => <TextField {...params} />}
                                                                />
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <Grid container spacing={2}>
                                                            <Grid item xs={6}>
                                                                <TimePicker
                                                                    label="Sunday Open"
                                                                    inputRef={sundayOpenRef}
                                                                    value={dayjs(branchData.sundayOpen.toString(), "hh:mm A")}
                                                                    onChange={(newValue) => handleTimeChange(newValue, 'sundayOpen')}
                                                                    renderInput={(params) => <TextField {...params} />}
                                                                />
                                                            </Grid>
                                                            <Grid item xs={6}>
                                                                <TimePicker
                                                                    label="Sunday Close"
                                                                    inputRef={sundayCloseRef}
                                                                    value={dayjs(branchData.saturdayClose.toString(), "hh:mm A")}
                                                                    onChange={(newValue) => handleTimeChange(newValue, 'saturdayClose')}
                                                                    renderInput={(params) => <TextField {...params} />}
                                                                />
                                                            </Grid>



                                                            {/* Delete Button */}


                                                            {/* Confirmation Dialog */}
                                                            <Dialog open={confirmDeleteOpen} onClose={handleDeleteDialogClose}>
                                                                <DialogTitle>Confirm Deletion</DialogTitle>
                                                                <DialogContent>
                                                                    <DialogContentText>
                                                                        Are you sure you want to delete this branch? This action cannot be undone.
                                                                    </DialogContentText>
                                                                </DialogContent>
                                                                <DialogActions>
                                                                    <Button onClick={handleDeleteDialogClose} color="secondary">
                                                                        Cancel
                                                                    </Button>
                                                                    <Button onClick={handleConfirmDelete} color="primary" autoFocus>
                                                                        Confirm
                                                                    </Button>
                                                                </DialogActions>
                                                            </Dialog>


                                                            <ConfirmDialog
                                                                open={open}
                                                                onClose={handleClose}
                                                                onConfirm={handleConfirm}
                                                                title="Confirm Approval"
                                                                content="Are you sure you want to approve this branch?"
                                                            />


                                                            <EditDialogBodyType
                                                                open={editOpen}
                                                                handleClose={() => setEditOpen(false)}
                                                                type={editType}
                                                                currentData={branchData} // Pass branch data here if needed
                                                                handleSave={handleApproveClick}
                                                            />


                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                            </LocalizationProvider>
                                        </Grid>




                                    </div>  </div>
                            </div></div>  </div>


                </div>
            </section>
        </main>

    );
};


export default BranchAdminView;
